import './App.css';
import formsDGT from './forms_dgt.json';
import provincias from './provincias.json';
import { MenuProps, verificaNIF} from "./utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
    Checkbox,
    Input,
    MenuItem,
    Button,
    NativeSelectRoot,
    NumberInput,
    NativeSelectField, HStack, IconButton,
    Field
} from "@chakra-ui/react";
import * as React from 'react'
import { useNavigate } from 'react-router-dom';
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { es } from 'date-fns/locale/es';
import Select from 'react-select';
import {LuMinus, LuPlus} from "react-icons/lu";
import { toaster } from "./components/ui/toaster";

function App() {
    let navigate = useNavigate();
    const [selectedValue, setSelectedValue] = React.useState('');
    const [selectedProvinceValue, setSelectedProvinceValue] = React.useState('');
    const [formData, setFormData] = React.useState({ "Provincia cita": "", certificates: [{ ficheroCertificadoDigital: null, txtPassCertificado: '', txtUsuarioClave: '', txtPassClave: '' }] });
    const [mandatoryFormData, setmandatoryFormData] = React.useState([]);
    const [showResidencia, setShowResidencia] = React.useState(false);
    const [addCita, setAddCita] = React.useState(false);
    const [datePickerEnabled, setdatePickerEnabled] = React.useState(false);
    const [allMandatoryFilled, setallMandatoryFilled] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    var current_date = new Date();
    const [endDate, setEndDate] = React.useState(new Date(current_date.getFullYear(), current_date.getMonth(), current_date.getDate() + 180));
    const [excludedDates, setExcludedDates] = React.useState([]);
    const [appointmentPrice, setappointmentPrice] = React.useState(0);
    registerLocale('es', es)

    const pemPublicKey = `
	-----BEGIN PUBLIC KEY-----
	MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmPBQf3n51xedWXL90yCr
	PLeqqZmcYnPiBHfp4URTFK4IQZQu9PSbKGQqroMqNXJ8KQM9S9POnh+xQCJuMRls
	GxMgDWuyS0/rtGyavlHo5twR4TkPCxP8S7zAG5XngEJHy04sMxzx6j7QteAKTtYF
	G/dtVDHkjtjzvzz+Zd0J6OpPPBaR+mywNO7XW85JmVjvQGb6erPQSKB2MhFH1WiZ
	CWw2A6sEoGAQIwwfAyNMeCkXLfLbpru55MR3qewjQiISuck0aiAYlYKURmC99Ryg
	pnQFAegzBgSrjuSHmLat75JZpTXCdQxkZfzPue/d8wYhbLCFcw1oMm+R2LcILyCr
	bwIDAQAB
	-----END PUBLIC KEY-----
	`

    const [importedPublicKey, setImportedPublicKey] = React.useState(null);

    React.useEffect(() => {
        setPaisCanje().catch((error) => {
            console.error('Error:', error);
            navigate('/expired');
        });
    }, []);

    const toBase64 = (file) => {
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(",")[1]); // Extract only Base64 part
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const decodeJwtPayload = (token) => {
        const parts = token.split(".");
        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        const payloadBase64 = parts[1];
        const decodedPayload = atob(payloadBase64);
        return JSON.parse(decodedPayload);
    };
    const [payload, setPayload] = React.useState(null);

    const setPaisCanje = async () => {
        const pemHeader = "-----BEGIN PUBLIC KEY-----";
        const pemFooter = "-----END PUBLIC KEY-----";
        const pemContents = pemPublicKey.trim().replace(pemHeader, "").replace(pemFooter, "");
        const binaryDerString = atob(pemContents);
        const binaryDer = str2ab(binaryDerString);

        setImportedPublicKey(await crypto.subtle.importKey(
            "spki",
            binaryDer,
            {
                name: "RSA-OAEP",
                hash: "SHA-256",
            },
            true,
            ["encrypt"]
        ));

        const defaultData = {"documento": "", "nombre": "", "txtAnnoCitado": "", "numero": "", "correo": "", "txtPaisNac": ""};
        const defaultMandatoryData = ["documento", "nombre", "txtAnnoCitado", "numero", "txtPaisNac"];

        const token = searchParams.get("token")
        const payload = decodeJwtPayload(token)
        payload["oficina"] = payload["oficina"] + "";
        setPayload(payload);

        if ((Date.now() / 1000) > payload["exp"]) {
            throw new Error("Payload expired!");
        }

        console.log(payload)

        defaultData["fechaMin"] = startDate.toLocaleDateString('en-GB')
        defaultData["fechaMax"] = endDate.toLocaleDateString('en-GB')
        defaultData["Observaciones"] = ""
        defaultData["token"] = token
        defaultData["tipo_bot"] = "ICP"
        defaultData["tipoCita"] = "ICP"
        defaultData["pageType"] = "ICP"
        defaultData["source"] = "TELEGRAM"
        defaultData["client_email"] = ""
        defaultData["timePreference"] = "any"
        defaultData["codTramite"] = payload["tramite"]
        setshowCertificateDialog(payload["clave"] == "MANDATORY" || payload["clave"] == "OPTIONAL");
        setCertificateSectionOpen(payload["clave"] == "MANDATORY");

        defaultData["price"] = payload["price"]
        defaultData["tguser"] = payload["tguser"]
        defaultData["rdbTipoDoc"] = "N.I.E."
        const newData = defaultData;
        console.log(newData)
        for (const [key, value] of Object.entries(newData)) {
            formData[key] = value
        }
        console.log(formData)

        setmandatoryFormData(defaultMandatoryData);

        const normalizedLocations = payload["sedes"].map((location) => ({
            value: location["id"],
            label: location["name"]
        }));

        setlocationOptions(normalizedLocations);

        if (payload["oficina"] !== "99") {
            const initialSelection = normalizedLocations.filter((location) => location.value === payload["oficina"]);
            setSelectedLocations(initialSelection);
            setFormData({
                ...formData,
                "oficinas": [payload["oficina"]],
                "sedes": initialSelection.map((location) => location.value)
            });
        } else {
            setSelectedLocations(normalizedLocations);
            setFormData({
                ...formData,
                "oficinas": ["99"],
                "sedes": normalizedLocations.map((location) => location.value)
            });
        }

        console.log(selectedLocations)
        console.log(payload)
        console.log(normalizedLocations)

        if ((payload["tramite"] === "40100" && payload["provincia"] === "Valencia")) {
            fetch('https://api.notifybotstg.com/api/get_avg_procedure', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({"tramite": payload["tramite"], "provincia": payload["provincia"]})
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data);
                    let pricing =  Math.max(data, 20).toString()
                    setappointmentPrice(pricing)
                    setFormData({
                        ...formData,
                        "txtPrice": pricing
                    });
                    setshowCustomPrice(true)
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    const str2ab = (str) => {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0; i < str.length; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    const encryptString = async (publicKey, data) => {
        const encodedData = str2ab(data);
        const encryptedData = await crypto.subtle.encrypt(
            {
                name: "RSA-OAEP",
            },
            publicKey,
            encodedData
        );
        return encryptedData;
    }

    const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }

    const addCertificate = () => {
        setFormData(prev => ({
            ...prev,
            certificates: [...prev.certificates, { ficheroCertificadoDigital: null, txtPassCertificado: '', txtUsuarioClave: '', txtPassClave: '' }]
        }));
    };

    const removeCertificate = (index) => {
        setFormData(prev => ({
            ...prev,
            certificates: prev.certificates.filter((_, i) => i !== index)
        }));
    };

    const handleCertificateChange = (index, field, value) => {
        setFormData(prev => {
            const newCerts = [...prev.certificates];
            newCerts[index][field] = value;
            return { ...prev, certificates: newCerts };
        });
    };

    const handleCertificateFileChange = (index, e) => {
        const file = e.target.files[0];
        setFormData(prev => {
            const newCerts = [...prev.certificates];
            newCerts[index].ficheroCertificadoDigital = file;
            return { ...prev, certificates: newCerts };
        });
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            console.log(formData);
            
            const certificatesData = await Promise.all(formData.certificates.map(async (cert) => {
                const certCopy = { ...cert };
                if (certCopy.ficheroCertificadoDigital) {
                    certCopy.certificate_data = await toBase64(certCopy.ficheroCertificadoDigital);
                    delete certCopy.ficheroCertificadoDigital;
                } else {
                    certCopy.certificate_data = "";
                }
                if (certCopy.txtPassCertificado !== "") {
                    const encryptedData = await encryptString(importedPublicKey, certCopy.txtPassCertificado);
                    certCopy.txtPassCertificado = arrayBufferToBase64(encryptedData);
                }
                if (certCopy.txtPassClave !== "") {
                    const encryptedData = await encryptString(importedPublicKey, certCopy.txtPassClave);
                    certCopy.txtPassClave = arrayBufferToBase64(encryptedData);
                }
                return certCopy;
            }));
            
            const nonEmptyCertificates = certificatesData.filter((cert) =>
                cert.certificate_data ||
                cert.txtPassCertificado ||
                cert.txtUsuarioClave ||
                cert.txtPassClave
            );

            const payloadFormData = { ...formData };
            if (nonEmptyCertificates.length > 0) {
                payloadFormData.certificates = nonEmptyCertificates;
            } else {
                delete payloadFormData.certificates;
            }

            try {
                const response = await fetch('https://api.notifybotstg.com/api/pro/new_appointment', {
                    method: 'POST',
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payloadFormData)
                });

                if (response.status === 400) {
                    const reason = (await response.text()) || "Solicitud inválida.";
                    toaster.create({
                        type: "error",
                        title: "Error",
                        description: reason,
                        duration: 9000,
                        meta: { closable: true }
                    });
                    return;
                }

                if (!response.ok) {
                    throw new Error(`Request failed with status ${response.status}`);
                }

                const data = await response.text();
                console.log('Success:', data);
                navigate('success');
            } catch (error) {
                console.error('Error:', error);
                navigate('error');
            }
        }
    };

    const validateForm = () => {
        var fulfilled = true;
        console.log(formData)

        if (formData["txtPaisNac"] === "Seleccionar") {
            fulfilled = false
        }

        mandatoryFormData.forEach(field => {
            console.log(field)
            if ((formData[field] === '') || (Array.isArray(formData[field]) && formData[field].length == 0)) {
                fulfilled = false;
                setallMandatoryFilled(true)
            }
        });

        fulfilled = fulfilled && (formData["rdbTipoDoc"] === "PASAPORTE" || verificaNIF(formData["documento"]));

        return fulfilled;
    };

    const handleInputChange = (event) => {
        console.log(event)

        setFormData({
            ...formData,
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value.trimStart()
        });


    };

    const handleChange = (options) => {
        if (!options || options.length === 0) {
            setSelectedLocations(locationOptions);
            setFormData({
                ...formData,
                "sedes": locationOptions.map((location) => location.value),
                "oficinas": locationOptions.map((location) => location.value)
            });
            return;
        }

        setFormData({
            ...formData,
            "sedes": options.map((option) => (option.value)),
            "oficinas": options.map((option) => (option.value))
        });

        setSelectedLocations(options);
    };

    const searchParams = new URLSearchParams(document.location.search)

    const [showOfficeSelect, setshowOfficeSelect] = React.useState(true);
    const [showCertificateDialog, setshowCertificateDialog] = React.useState(false);
    const [showCustomPrice, setshowCustomPrice] = React.useState(false);
    const [certificateSectionOpen, setCertificateSectionOpen] = React.useState(false);

    const [tipoDoc, setTipoDoc] = React.useState('N.I.E.');
    const [locationOptions, setlocationOptions] = React.useState([]);
    const [selectedLocations, setSelectedLocations] = React.useState([]);

    return (
        <div>
            <div className="form">
                <div className="grid-container">
                    {showOfficeSelect && <div className="input-wrapper">
                        <label>Selecciona la(s) oficina(s)</label>
                        <Select
                            name="Oficinas"
                            isMulti
                            options={locationOptions}
                            value={selectedLocations}
                            onChange={handleChange}
                            className="basic-multi-select"
                            classNamePrefix="select">
                        </Select>
                        <label>Rellena los campos obligatorios *</label>
                    </div>}
                    <div key="rdbTipoDoc" className="input-wrapper">
                        <label>Tipo de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <RadioGroup
                            name="rdbTipoDoc"
                            value={tipoDoc}
                            onChange={(newValue) => {
                                setTipoDoc(newValue.target.value)
                                formData["rdbTipoDoc"] = newValue.target.value
                            }}
                        >
                            <FormControlLabel value="N.I.E." control={<Radio/>} label="N.I.E."/>
                            <FormControlLabel value="PASAPORTE" control={<Radio/>} label="PASAPORTE"/>
                            <FormControlLabel value="D.N.I." control={<Radio/>} label="D.N.I."/>
                        </RadioGroup>
                    </div>
                    <div key="documento" className="input-wrapper">
                        <label>Número de documento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["documento"] !== undefined && !(formData["rdbTipoDoc"] === "PASAPORTE" || verificaNIF(formData["documento"]))}>
                            <Input
                                name="documento"
                                type="text"
                                value={formData["documento"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                                maxLength={15}
                            />
                            <Field.ErrorText>Introduce un documento valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="nombre" className="input-wrapper">
                        <label>Nombre y apellidos<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="nombre"
                            type="text"
                            value={formData["nombre"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div key="txtAnnoCitado" className="input-wrapper">
                        <label>Año de nacimiento<b style={{color: 'red'}}>{" *"}</b></label>
                        <Input
                            name="txtAnnoCitado"
                            type="number"
                            value={formData["txtAnnoCitado"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    <div id="txtPaisNac" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>País de nacionalidad <b style={{color: 'red'}}> *</b></label>
                        <NativeSelectRoot width="240px" name="txtPaisNac"
                                          value={selectedProvinceValue} onChange={handleInputChange}>
                            <NativeSelectField name="txtPaisNac">
                                <option key="Seleccionar" value="Seleccionar">Seleccionar</option>
                                {provincias.map(opt => (
                                    <option name="txtPaisNac" key={opt} value={opt}>{opt}</option>
                                ))}
                            </NativeSelectField>
                        </NativeSelectRoot>
                    </div>
                    <div key="numero" className="input-wrapper">
                        <label>Teléfono<b style={{color: 'red'}}>{" *"}</b></label>
                        <Field.Root invalid={formData["numero"] && (formData["numero"].length < 9 && formData["numero"].length > 0)}>
                            <Input
                                name="numero"
                                type="tel"
                                value={formData["numero"] || ''}
                                onChange={handleInputChange}
                                placeholder=''
                                minLength={9}
                                maxLength={9}
                            />
                            <Field.ErrorText>Introduce un teléfono valido</Field.ErrorText>
                        </Field.Root>
                    </div>
                    <div key="correo" className="input-wrapper">
                        <label>Correo electrónico</label>
                        <div></div>
                        <label>El justificante se enviara al correo especificado, dejar el campo vacío para generar una dirección aleatoria</label>
                        <Input
                            name="correo"
                            type="email"
                            value={formData["correo"] || ''}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </div>
                    { true &&
                    <div id="fechaMin" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Fecha minima de la cita</label>
                        <DatePicker
                            showIcon
                            selected={startDate}
                            onSelect={(date) => setStartDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "fechaMin",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setStartDate(date.toDate());
                                }
                            }}
                            name="fechaMin"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            locale="es"
                        />
                    </div>
                    }
                    { true &&
                    <div id="fechaMax" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>Fecha maxima de la cita</label>
                        <DatePicker
                            showIcon
                            selected={endDate}
                            onSelect={(date) => setEndDate(date)}
                            onChange={(date) => {
                                var event = {
                                    "target": {
                                        "name": "fechaMax",
                                        "value": date.toLocaleDateString('en-GB'),
                                        "type": "datepicker"
                                    }
                                };
                                handleInputChange(event)
                            }}
                            onChangeRaw={event => {
                                const date = moment(event.target.value, "DD/MM/YYYY");
                                if (date.isValid()) {
                                    setEndDate(date.toDate());
                                }
                            }}
                            name="fechaMax"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            minDate={startDate}
                            locale="es"
                        />
                    </div>
                    }
                    { true &&
                    <div id="ExcludedDates" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex"}}>
                        <label>No quiero que se reserve la cita estos días</label>
                        <DatePicker
                            showIcon
                            selected={null}
                            onChange={(date) => {
                                if (date) {
                                    const dateExists = excludedDates.some(excludedDate => 
                                        excludedDate.toDateString() === date.toDateString()
                                    );
                                    
                                    let newExcludedDates;
                                    if (dateExists) {
                                        // Remove the date if it already exists
                                        newExcludedDates = excludedDates.filter(excludedDate => 
                                            excludedDate.toDateString() !== date.toDateString()
                                        );
                                    } else {
                                        // Add the date if it doesn't exist
                                        newExcludedDates = [...excludedDates, date];
                                    }
                                    
                                    setExcludedDates(newExcludedDates);
                                    var event = {
                                        "target": {
                                            "name": "ExcludedDates",
                                            "value": newExcludedDates.map(d => d.toLocaleDateString('en-GB')).join(','),
                                            "type": "datepicker"
                                        }
                                    };
                                    handleInputChange(event);
                                }
                            }}
                            highlightDates={excludedDates}
                            dayClassName={(date) => {
                                return excludedDates.some(excludedDate => 
                                    excludedDate.toDateString() === date.toDateString()
                                ) ? "excluded-date" : undefined;
                            }}
                            name="ExcludedDates"
                            className="form-control excluded-dates-picker"
                            dateFormat="dd/MM/yyyy"
                            minDate={startDate}
                            maxDate={endDate}
                            locale="es"
                            placeholderText="Seleccionar fechas a excluir"
                            inline={window.innerWidth <= 768}
                            shouldCloseOnSelect={false}
                        />
                        {excludedDates.length > 0 && (
                            <div className="excluded-dates-display">
                                <small style={{color: '#666', marginTop: '8px', display: 'block'}}>
                                    Fechas excluidas: {excludedDates.map(date => date.toLocaleDateString('es-ES')).join(', ')}
                                </small>
                            </div>
                        )}
                    </div>
                    }
                    <div id="txtObservaciones" className="input-wrapper"
                         style={{display: showResidencia ? "none" : "flex", paddingBottom: "10px"}}>
                        <label>Observaciones</label>
                        <Input
                            name={"txtObservaciones"}
                            type="text"
                            value={formData["txtObservaciones"] || ''}
                            onChange={handleInputChange}
                            placeholder={""}
                        />
                    </div>
                    {showCustomPrice &&
                    <div key="txtPrice" className="input-wrapper">
                        <label>Precio cita (€)<b style={{color: 'red'}}>{" *"}</b></label>
                        <div></div>
                        <label>La prioridad de búsqueda se ajustara en función del precio a pagar. El valor por defecto corresponde al precio medio del sistema</label>
                        <NumberInput.Root
                            width="200px"
                            defaultValue={formData["txtPrice"] || appointmentPrice}
                            onChange={handleInputChange}
                            onValueChange={({ value }) => {
                                formData["txtPrice"] = value
                            }}
                            min={Math.max(Math.round(appointmentPrice * 0.9), 20)}
                            max={150}
                            unstyled spinOnPress={false}>
                            <HStack gap="2">
                                <NumberInput.DecrementTrigger asChild>
                                    <IconButton variant="outline" size="sm">
                                        <LuMinus />
                                    </IconButton>
                                </NumberInput.DecrementTrigger>
                                <NumberInput.ValueText textAlign="center" fontSize="lg" minW="3ch" />
                                <NumberInput.IncrementTrigger asChild>
                                    <IconButton variant="outline" size="sm">
                                        <LuPlus />
                                    </IconButton>
                                </NumberInput.IncrementTrigger>
                            </HStack>
                        </NumberInput.Root>
                    </div>
                    }
                    {showCertificateDialog &&
                        <div className="certificate-dropdown">
                            <Button onClick={() => setCertificateSectionOpen((prev) => !prev)} style={{display: payload["clave"] == "MANDATORY" ? "none" : "block"}}>
                                {certificateSectionOpen ? "Ocultar certificados digitales" : "Añadir certificados digitales"}
                            </Button>
                            {certificateSectionOpen &&
                                <>
                                    <div key="xplanation" className="input-wrapper">
                                        <label>{payload["clave"] == "MANDATORY" ? "La solicitud de esta cita requiere de ser presentada mediante un certificado digital." : "La solicitud de esta cita puede ser presentada mediante un certificado digital."}
                                            Deberás subir un fichero de certificado digital en formato .p12 o .pfx junto a su
                                            contraseña.
                                            <b>El usuario de esta aplicación actua como único dueño y responsable de estas
                                                credenciales
                                                aportadas que serán utilizadas por RobotCita Extranjería con el único proposito de
                                                confirmar
                                                la cita previa</b></label>
                                    </div>
                                    {formData.certificates.map((cert, index) => (
                                        <div key={index} className="certificate-section">
                                            <h3>Certificado {index + 1}</h3>
                                            <div className="input-wrapper">
                                                <label>Fichero certificado digital</label>
                                                <input type="file" onChange={(e) => handleCertificateFileChange(index, e)} accept={".p12, .pfx"} />
                                            </div>
                                            <div className="input-wrapper">
                                                <label>Contraseña fichero certificado digital</label>
                                                <Input
                                                    type="text"
                                                    value={cert.txtPassCertificado || ''}
                                                    onChange={(e) => handleCertificateChange(index, 'txtPassCertificado', e.target.value)}
                                                    placeholder=''
                                                />
                                            </div>
                                            <div className="input-wrapper">
                                                <label>Usuario CL@VE PERMANENTE</label>
                                                <Input
                                                    type="text"
                                                    value={cert.txtUsuarioClave || ''}
                                                    onChange={(e) => handleCertificateChange(index, 'txtUsuarioClave', e.target.value)}
                                                    placeholder=''
                                                />
                                            </div>
                                            <div className="input-wrapper">
                                                <label>Contraseña CL@VE PERMANENTE</label>
                                                <Input
                                                    type="text"
                                                    value={cert.txtPassClave || ''}
                                                    onChange={(e) => handleCertificateChange(index, 'txtPassClave', e.target.value)}
                                                    placeholder=''
                                                />
                                            </div>
                                            {formData.certificates.length > 1 && (
                                                <Button onClick={() => removeCertificate(index)}>Eliminar este certificado</Button>
                                            )}
                                        </div>
                                    ))}
                                    <Button onClick={addCertificate}>Añadir otro certificado</Button>
                                </>
                            }
                        </div>
                    }

                    <Button style={{width: "100%"}} class="sendButton" variant="contained" color="primary"
                            onClick={handleSubmit}
                    >Enviar solicitud</Button>
                </div>
                {allMandatoryFilled && <p>Rellena todos los campos obligatorios *</p>}
                <div></div>
            </div>
        </div>
    );
}

export default App;
